import { ApiUserActionUser } from "@incendium/api";
import { NOT_SET } from "features/analytics/constants/constants";

export function formatOptionalText(value: unknown) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed || trimmed.toLowerCase() === NOT_SET.toLowerCase()) {
    return "-";
  }
  return trimmed;
}

export function formatCustomerCellLabel(name: unknown, leadKey: unknown) {
  const formattedName = formatOptionalText(name);
  if (formattedName !== "-") {
    return formattedName;
  }

  const formattedLeadKey = formatOptionalText(leadKey);
  if (formattedLeadKey !== "-") {
    return formattedLeadKey;
  }

  return "-";
}

export function getCustomerDisplayName(
  customer: ApiUserActionUser | undefined,
  leadId: number,
) {
  if (customer?.key) {
    return customer.key;
  }
  if (customer?.email) {
    const local = customer.email.split("@")[0] || "";
    return local
      .split(/[._-]+/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }
  return leadId ? `Customer ${leadId}` : "-";
}

export function getCustomerLabel(
  leadId: number,
  customersByLeadId: Record<number, ApiUserActionUser>,
) {
  const customer = customersByLeadId[leadId];
  if (!customer) {
    return "-";
  }
  return customer.email || customer.key || "-";
}
